import http from "../httpService";
import {getBaseUrl} from "../../config";

export const submitPaymentReport = (data, paginate) => {

  if (!paginate) {
    return http.post(
      `${getBaseUrl()}/payment_report`,
      data
    );
  }
  return http.post(
    `${getBaseUrl()}/payment_report?${paginate}`,
    data
  );
};
